import { useState } from "react";
import { Download, FileText, FileSpreadsheet, Folder, Table2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { toast } from "sonner";
import axios from "axios";

import { API_URL } from "@/lib/api";
const API = `${API_URL}/api`;

const ExportReportButton = ({ products, filters, searchTerm, onOpenExplorer }) => {
  const [generating, setGenerating] = useState(false);

  const generateReport = async (format) => {
    if (products.length === 0) { toast.error("No hay productos para exportar"); return; }

    setGenerating(true);
    toast.info(`Generando ${format.toUpperCase()}...`);

    try {
      const params = new URLSearchParams({ format });
      if (searchTerm) params.append('search', searchTerm);
      if (filters.familia) params.append('familia', filters.familia);
      if (filters.subfamilia) params.append('subfamilia', filters.subfamilia);
      if (filters.loteInicio) params.append('lote_inicio', filters.loteInicio);
      if (filters.loteFinal) params.append('lote_final', filters.loteFinal);
      if (filters.stockMin) params.append('stock_min', filters.stockMin);
      if (filters.stockMax) params.append('stock_max', filters.stockMax);

      const response = await axios.post(`${API}/reports/generate?${params.toString()}`);
      const { filename, products_count } = response.data;

      toast.success(`Reporte generado: ${filename} (${products_count} productos)`);
      if (onOpenExplorer) onOpenExplorer();
    } catch (error) {
      toast.error(`Error al generar el ${format.toUpperCase()}`);
    } finally {
      setGenerating(false);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            data-testid="export-report-button"
            variant="outline"
            disabled={products.length === 0 || generating}
            className="body-font border-sky-600 text-sky-700 hover:bg-[#FF9900]/10"
          >
            {generating ? (
              <><div className="w-4 h-4 border-2 border-sky-600 border-t-transparent rounded-full animate-spin mr-2" />Generando...</>
            ) : (
              <><Download className="w-4 h-4 mr-2" />Descargar Reporte ({products.length})</>
            )}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-48">
          <DropdownMenuItem onClick={() => generateReport('pdf')} data-testid="export-pdf-option" className="cursor-pointer">
            <FileText className="w-4 h-4 mr-2 text-rose-600" />
            <span className="body-font">Generar PDF</span>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => generateReport('xlsx')} data-testid="export-xlsx-option" className="cursor-pointer">
            <Table2 className="w-4 h-4 mr-2 text-[#FF9900]" />
            <span className="body-font">Generar Excel</span>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => generateReport('csv')} data-testid="export-csv-option" className="cursor-pointer">
            <FileSpreadsheet className="w-4 h-4 mr-2 text-emerald-600" />
            <span className="body-font">Generar CSV</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      {onOpenExplorer && (
        <Button
          data-testid="open-reports-explorer-button"
          variant="outline"
          onClick={onOpenExplorer}
          className="body-font border-border text-muted-foreground hover:bg-muted"
        >
          <Folder className="w-4 h-4 mr-2 text-[#FF9900]" />
          Ver Reportes
        </Button>
      )}
    </div>
  );
};

export default ExportReportButton;
